import React, { useState, useEffect, createRef } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import facilityService from "../services/facility-service";
import documentService from "../services/document-service";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { Multiselect } from "multiselect-react-dropdown";

const UploadDocuments = ({ history }) => {
  const [facSelected, setFacSelected] = useState("");
  const [facilityList, setFacilitiesList] = useState();
  const [documentName, setDocumentName] = useState("");
  const [fileContent, setFileContent] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const multiselectRef = createRef();

  useEffect(() => {
    getFacilities();
  }, []);

  function facSelect() {
    let currentValue = multiselectRef.current.getSelectedItems();
    let final_array = currentValue.map((p) => p.id);
    setFacSelected(final_array);
  }
  async function getFacilities() {
    try {
      setLoading(true);
      let totalFacList = await facilityService.getFacilities();
      totalFacList.sort((a, b) => a.name.localeCompare(b.name));
      setFacilitiesList(totalFacList);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting facilities details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  }
  const handleUpload = async (event) => {
    if (documentName.length === 0 || facSelected.length === 0 || Object.getPrototypeOf(fileContent) === Object.prototype) {
      setError(true);
      return;
    }

    try {
      let formDataUrl = new FormData();
      formDataUrl.append("formFile", fileContent);
      formDataUrl.append("enctype", "multipart/form-data");
      let respUrl = await documentService.getDocumentUrl(formDataUrl);

      let params = {
        doc_name: documentName,
        fac_list: facSelected.join(","),
        doc_path: respUrl,
      };

      await documentService.uploadDocument(params);
      window.location.reload();
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error uploading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 h-24">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">UPLOAD DOCUMENTS</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <ul className="text-left">
            <li className="inline-block text-xs leading-6 w-full mb-4">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Facility
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              {facilityList ? (
                <Multiselect
                  name="facility"
                  displayValue="name"
                  options={facilityList}
                  ref={multiselectRef}
                  onSelect={(e) => {
                    facSelect(true);
                  }}
                  onRemove={(e) => {
                    facSelect(false);
                  }}
                />
              ) : (
                ""
              )}

              {error && facSelected.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                  You must specify facilty
                </p>
              )}
            </li>

            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Document name
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <input
                id="document_name"
                name="document_name"
                type="text"
                value={documentName}
                onChange={(e) => setDocumentName(e.target.value)}
                className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
              />
              {error && documentName.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                  You must specify name
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-8 w-full">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Upload Document
              </label>
              <input
                id="upload"
                name="upload"
                type="file"
                onChange={(e) => {
                  setFileContent(e.target.files[0]);
                }}
                className="focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-1/2"
              />
              {error && Object.getPrototypeOf(fileContent) === Object.prototype && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                  You must select document
                </p>
              )}
            </li>

            <li className="inline-block text-sm leading-8 w-full">
              <button
                type="submit"
                className="text-white rounded  font-medium h-10 text-white w-full bg-secondary bg-login_btn mb-3 mt-3 focus:outline-none"
                aria-label="Upload document"
                onClick={handleUpload}
              >
                UPLOAD
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(UploadDocuments)
);
